import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contato" className="py-12 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('contact_title')}
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {/* Agendar Reunião */}
          <a
            href="https://outlook.office.com/book/Catlogodeequipamentosconstruo@moviis.com.br/?ismsaljsauthenabled"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-800 hover:bg-gray-900 text-white rounded-lg p-6 sm:p-8 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer"
          >
            <div className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-white/10 rounded-full mb-4 sm:mb-6 mx-auto">
              <i className="ri-calendar-line text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-center mb-2 sm:mb-3">
              {t('contact_schedule_title')}
            </h3>
            <p className="text-center text-gray-300 text-sm sm:text-base">
              {t('contact_schedule_desc')}
            </p>
          </a>

          {/* Fale Conosco */}
          <a
            href="mailto:lp@moviis.com.br"
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-lg p-6 sm:p-8 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer"
          >
            <div className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-white/20 rounded-full mb-4 sm:mb-6 mx-auto">
              <i className="ri-mail-line text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-center mb-2 sm:mb-3">
              {t('contact_email_title')}
            </h3>
            <p className="text-center text-white/90 text-sm sm:text-base">
              {t('contact_email_desc')}
            </p>
          </a>
        </div>
      </div>
    </section>
  );
}